import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IHeaderState } from './interfaces/header.interface';
import { Observable } from '@reactivex/rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private headerCorrespondenceUpdateSubject = new Subject<IHeaderState>();
  headerCorrespondenceUpdateState = this.headerCorrespondenceUpdateSubject.asObservable();
  private recallUpdated = new Subject<boolean>();
  update() {
    this.headerCorrespondenceUpdateSubject.next({updateCorrespondence: true} as IHeaderState);
  }

  stopUpdate() {
    this.headerCorrespondenceUpdateSubject.next({updateCorrespondence: false} as IHeaderState);
  }

  updateRecall(state:boolean){
    this.recallUpdated.next(state);
  }
  
  triggerRecall(): Observable<boolean> {
    return this.recallUpdated.asObservable();
  }
  
}
